var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.abierto)?_c('solicitarCampamentos',{on:{"leemos":_vm.leemos}}):_c('div',[_c('h3',{staticClass:"text-center"},[_c('br'),_vm._v("PLAN DE VACACIONES CERRADO")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }